import React, { useContext, useEffect, useState } from 'react';
import { Button, CardBody, CardFooter, Col, Form, FormFeedback, Input, Label, Row, Spinner } from 'reactstrap';
import { GlobalStore } from '../../../StateStores';
import { toast } from 'react-toastify';
import { createInspectionTransaction } from '../../../Actions/InspectionActs';
import { NavLink, redirect, useNavigate } from 'react-router-dom';

const AddInspection = ({})=>{
    const navigate = useNavigate();
    const [formValid, setFormValid] = useState(false);
    const [form,setForm] = useState({});
    const [formErrors,setFormErrors] = useState({
        route_from:'Starting point is required',
        route_to:'Final destination is required',
        route_remarks:'Remaks is required',
    });

    useEffect(() => {
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    const {InspectionDispatch,InspectionState:{
        fetchVehiclePendingInspection:{
            error:vehicleError,
            loading:vehicleLoading,
            data:vehicleData},
        addInspection:{error,loading,data},
    }} = useContext(GlobalStore);

    const onChange = ({name,value}) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();

        if(formValid){
            

            try {
                const {vehicle,insurance} = vehicleData.data;

                const response = await createInspectionTransaction({
                    ...form,
                    ...vehicle,
                    ...insurance})(InspectionDispatch);

                if(response.status){
                    toast.success(response.message);
                    // const inspectionMasterId = response?.data?.inspection_master_id;
                    // window.location.href = `/vehicle-inspection/form?inspection_master_id=${inspectionMasterId}`;
                }else{
                    toast.error(response.message)
                }
            } catch (error) {
                toast.error(error.message)
            }
        }
    }

    return(
        <React.Fragment>
            <Form onSubmit={onSubmit}>
                <CardBody>
                    <Row>
                        <Col>
                            <Label>Starting point</Label>
                            <Input 
                                type='text' 
                                placeholder='From location'
                                value={form?.route_from}
                                onChange={(e) => onChange({name:'route_from',value:e.target.value})}
                                valid={formErrors.route_from === ''}
                                invalid={formErrors.route_from !== ''}
                            />
                            {formErrors.route_from && <FormFeedback>{formErrors.route_from}</FormFeedback>}
                        </Col>
                        <Col>
                            <Label>Final destination</Label>
                            <Input 
                                type='text' 
                                placeholder='To location'
                                value={form?.route_to}
                                onChange={(e) => onChange({name:'route_to',value:e.target.value})}
                                valid={formErrors.route_to === ''}
                                invalid={formErrors.route_to !== ''}
                            />
                            {formErrors.route_to && <FormFeedback>{formErrors.route_to}</FormFeedback>}
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                        <Col>
                            <Label>Remaks</Label>
                            <Input 
                                type='textarea' 
                                placeholder='Remarks'
                                value={form?.route_remarks}
                                onChange={(e) => onChange({name:'route_remarks',value:e.target.value})}
                                valid={formErrors.route_remarks === ''}
                                invalid={formErrors.route_remarks !== ''}
                            />
                            {formErrors.route_remarks && <FormFeedback>{formErrors.route_remarks}</FormFeedback>}
                        </Col>
                    </Row>
                </CardBody>
                <CardFooter>
                    <div className='d-flex justify-content-end'>
                        <Button disabled={!data?.data?.inspection_master_id}>
                            <NavLink 
                                to="/vehicle-inspection/form" 
                                state={{ inspection_master_id: data?.data?.inspection_master_id }}
                                className="nav-link fs-13">
                                <span className="icon-ws menu-titlse">Proceed</span>
                            </NavLink>
                        </Button>
                        <Button className='ms-1' disabled={!formValid} size='sm'>
                            {loading && <Spinner size="sm"/>}
                            <span className='ms-1'>Save</span>
                        </Button>
                    </div>
                </CardFooter>
            </Form>
        </React.Fragment>
    )
}

export default AddInspection;